





































































































import { Component, Prop, Vue } from "@/shared/vuepack";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useUserBankAccountStore } from "@/shared/store/userBankAccount";
import { useCardProviderOptionsStore } from "@/employer/store/cardProviderOptions";
import { AuthenticationProvider, CardProvider, Permission, UserPermission } from "@/shared/types";
import AccountBalanceWidget from "@/shared/widgets/AccountBalanceWidget.vue";
import ContributionsGraphWidget from "@/shared/components/contribution/ContributionsGraphWidget.vue";
import AccountHolderInvestment from "@/employer/components/partner-ee-service/v2/AccountHolderInvestment.vue";
import AccountHolderBilling from "@/employer/components/partner-ee-service/v2/AccountHolderBilling.vue";
import AccountHolderDependents from "@/employer/components/partner-ee-service/v2/AccountHolderDependents.vue";
import AccountHolderBeneficiaries from "@/employer/components/partner-ee-service/v2/AccountHolderBeneficiaries.vue";
import AccountHolderAuthorizedSigners
  from "@/employer/components/partner-ee-service/v2/AccountHolderAuthorizedSigners.vue";
import AccountHolderCredentials from "@/employer/components/partner-ee-service/v2/AccountHolderCredentials.vue";
import AccountHolderDetails from "@/shared/components/AccountHolderDetails.vue";
import AccountHolderUserSystemId from "@/employer/components/partner-ee-service/v2/AccountHolderUserSystemId.vue";
import AccountHolderBankAccountHolds
  from "@/employer/components/partner-ee-service/v2/AccountHolderBankAccountHolds.vue";
import AccountHolderNotes from "@/employer/components/partner-ee-service/v2/AccountHolderNotes.vue";
import AccountHolderEmployer from "@/employer/components/partner-ee-service/v2/AccountHolderEmployer.vue";
import AccountHolderDebitCards from "@/employer/components/partner-ee-service/v2/AccountHolderDebitCards.vue";
import AccountHolderNotionalAccounts from "@/employer/components/partner-ee-service/v2/AccountHolderNotionalAccounts.vue";
import AccountHolderExternalBankAccounts
  from "@/employer/components/partner-ee-service/v2/AccountHolderExternalBankAccounts.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    AccountBalanceWidget,
    ContributionsGraphWidget,
    AccountHolderInvestment,
    AccountHolderBilling,
    AccountHolderDependents,
    AccountHolderBeneficiaries,
    AccountHolderAuthorizedSigners,
    AccountHolderCredentials,
    AccountHolderDetails,
    AccountHolderUserSystemId,
    AccountHolderBankAccountHolds,
    AccountHolderNotes,
    AccountHolderEmployer,
    AccountHolderDebitCards,
    AccountHolderNotionalAccounts,
    AccountHolderExternalBankAccounts
  }
})
export default class extends Vue {
  rolePermissionStore = useRolePermissionsStore();
  custodianSettingsStore = useCustodianSettingsStore();
  userBankAccountStore = useUserBankAccountStore();
  cardProviderOptionsStore = useCardProviderOptionsStore();
  drivewealthStore = useDrivewealthStore();

  @Prop ()
  username: string;

  @Prop ()
  partnerId: number;

  @Prop()
  routeToContributions: Location;

  canEditProfile = false;

  get hasAccountInfoReadPermision () {
    return this.rolePermissionStore.userHasPartnerPermission(Permission.HsaAccountInfoRead, this.partnerId);
  }

  get displayAccountHolderBilling () {
    return !this.custodianSettingsStore.isHsaBankCustodian && this.hasAccountInfoReadPermision;
  }

  get bankAccountHoldsVisible () {
    return this.custodianSettingsStore.displayBankAccountHolds;
  }

  get displayAuthorizedSigners () {
    return this.custodianSettingsStore.isHsaBankCustodian && this.hasHsaAccount;
  }

  get displayBeneficiaries () {
    return this.custodianSettingsStore.isHsaBankCustodian && this.hasHsaAccount;
  }

  get displayConsumerNotes () {
    return this.custodianSettingsStore.isHsaBankCustodian;
  }

  get displayEmploymentInfo () {
    return this.custodianSettingsStore.isHsaBankCustodian && this.hasHsaAccount;
  }
  get displayDebitCards () {
    return this.custodianSettingsStore.isHsaBankCustodian && this.isFiservCardholder;
  }
  get displayNotionalAccounts (): boolean {
    return this.custodianSettingsStore.isHsaBankCustodian;
  }
  get isFiservCardholder () {
    return this.cardProvider === CardProvider.Fiserv;
  }

  get cardProvider () {
    return this.cardProviderOptionsStore.cardProviderOptions
      ? this.cardProviderOptionsStore.cardProviderOptions.cardProvider
      : CardProvider.None;
  }

  get hasHsaAccount () {
    return this.userBankAccountStore.hsaAccountsLoaded &&
      this.userBankAccountStore.hsaAccounts.length > 0 &&
      this.userBankAccountStore.accountNumber !== null;
  }

  get hasInvestmentViewPermission (): boolean {
    return this.rolePermissionStore.doesUserHavePermission(
      UserPermission.PartnerPortalInvestmentView
    );
  }

  get hasManageUserLogin () {
    return this.rolePermissionStore.userHasPartnerPermission(Permission.PartnerManageUserLogin, this.partnerId);
  }

  get hasManageFraud () {
    return this.rolePermissionStore.userHasPartnerPermission(Permission.PartnerManageIdp, this.partnerId);
  }

  created () {
    const args = { username: this.username, partnerId: this.partnerId };
    this.userBankAccountStore.loadHsaAccounts(args);
    this.cardProviderOptionsStore.loadCardProviderOptions(args);
    this.drivewealthStore.loadAccountSummariesV2(args);
  }

  handleCredentialsLoaded (profile: any) {
    if (profile) {
      this.canEditProfile = (profile.status === "staged" || profile.isCredentialed === false) &&
        profile.provider === AuthenticationProvider.Okta;
    }
  }
}
